import script from "./Step4Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Step4Form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__